import { app } from '@/bootloader';
// import coordinatorUtilizationChart from '@/components/charts/dashboard/coordinatorUtilizationChart.vue';
// import dailyCoresUsageChart from '@/components/charts/dashboard/dailyCoresUsageChart.vue';
// import chartPlaceholder from '@/components/charts/dashboard/chartPlaceholder.vue';
// import lineChart from '@/components/charts/lineChart.vue';
// import pieChart from '@/components/charts/agents/AgentDiskSpaceChart.vue';
// import barChart from '@/components/charts/barChart.vue';
// import workloadChart from '@/components/charts/dashboard/workloadUtilizationChart.vue';
// import workloadByChart from '@/components/charts/dashboard/workloadByChart.vue';
// import agentsUtilizationChart from '@/components/charts/dashboard/agentsUtilizationChart.vue';
// import AgentName from '@/views/agents/components/agents-table/components/Cells/AgentName.vue';
import IncrediContextMenu from '@/modules/IncrediContextMenu';
import VueVirtualScroller from 'vue-virtual-scroller';
import IdleVue from 'idle-vue';
import store from '@/store';

import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

app.use(IdleVue, {
  eventEmitter: app.config.globalProperties.$eventHub,
  idleTime: parseInt(process.env.VUE_APP_IDLE_TIMEOUT as any) * 60000,
  store,
  events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
  startAtIdle: false,
});
app.use(VueVirtualScroller);
app.use(IncrediContextMenu);
// app.component('coordinator-utilization-chart', coordinatorUtilizationChart);
// app.component('daily-cores-usage-chart', dailyCoresUsageChart);
// app.component('chart-placeholder', chartPlaceholder);
// app.component('line-chart', lineChart);
// app.component('pie-chart', pieChart);
// app.component('bar-chart', barChart);
// app.component('workload-chart', workloadChart);
// app.component('workload-by-chart', workloadByChart);
// app.component('agents-utilization-chart', agentsUtilizationChart);
// app.component('AgentName', AgentName);
